import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {baseColors} from "../../../../themes/definitions/mrgreen/base-colors";

const UserMenuSeparatorDefaultBox = styled.div`
    box-sizing: content-box;
    height: 1px;
    background-color: ${({theme}) => theme.colors.backgroundDark};
    box-shadow: 0px 0.35px 0px 0px ${({theme}) => theme.colors.boxBorderContrast};
    margin-bottom: 1px;
`;

const UserMenuSeparatorCasino777Box = styled(UserMenuSeparatorDefaultBox)`
    box-shadow: 0px 0.25px 0px 0px ${({theme}) => theme.colors.boxBorderContrast};
`;

const UserMenuSeparatorMrGreenBox = styled(UserMenuSeparatorDefaultBox)`
    background-color: ${baseColors.gray233};
    opacity: 0.2;
`;

const UserMenuSeparatorSIBox = styled(UserMenuSeparatorDefaultBox)`
    box-shadow: 0px 0.35px 0px 0px ${({theme}) => theme.colors.boxBorderLighter};
`;

export const UserMenuSeparatorBox = styledByTheme(UserMenuSeparatorDefaultBox)
    .forCasino777(UserMenuSeparatorCasino777Box)
    .forMrGreen(UserMenuSeparatorMrGreenBox)
    .forSI(UserMenuSeparatorSIBox)
    .apply()